<template>
<div class="app">
	<b-navbar toggleable="xl" type="dark" variant="dark" sticky fixed>
		<b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
			<b-navbar-brand href="#"><img src="./assets/logo.png" height="32"></img></b-navbar-brand>
			<b-collapse is-nav id="nav_collapse">
				<b-navbar-nav>
					<!--
					<b-nav-item v-b-toggle.sidebar-1>Side</b-nav-item>
					-->
					<b-nav-item to="/">Home</b-nav-item>
					<b-nav-item v-if="authenticationService.isAuthenticated() === true" to="/workbench">SQL Workbench</b-nav-item>
					<b-nav-item v-if="authenticationService.isAuthenticated() === true" to="/filesystem">File System</b-nav-item>
				</b-navbar-nav>
				<b-navbar-nav class="ml-auto">
					<b-nav-item v-if="authenticationService.isAuthenticated() === false" to="/login"">Login</b-nav-item>
					<b-nav-item-dropdown id="user-dropdown" v-if="authenticationService.isAuthenticated() === true" :text="user.displayName" toggle-class="nav-link-custom" right>
						<template v-slot:button-content>
							<b-img :src="user.imageUrl" rounded="circle" width="32"></b-img>&nbsp;{{user.displayName}}
						</template>
						<!-- 
						<b-dropdown-item to="/user/profile">User Profile</b-dropdown-item>
						 -->
						<b-dropdown-item to="/user/password">Change Password</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item @click="logout()">Logout</b-dropdown-item>
					</b-nav-item-dropdown>
					<b-nav-item-dropdown id="help-dropdown" text="Help" toggle-class="nav-link-custom" right>
						<b-dropdown-item to="/help">Help</b-dropdown-item>
						<b-dropdown-item href="https://www.teedrei.com" target="new">Documentation</b-dropdown-item>
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item to="/about">About</b-dropdown-item>
					</b-nav-item-dropdown>
				</b-navbar-nav>
			</b-navbar-nav>
		</b-collapse>
	</b-navbar>
	<!--
	<b-sidebar id="sidebar-1" title="Sidebar" shadow>
		<div class="px-3 py-2">
			<p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis
				in, egestas eget quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.
			</p>
		<b-img src="https://picsum.photos/500/500/?image=54" fluid thumbnail></b-img>
		</div>
	</b-sidebar>
	-->
	<router-view/>
</div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {authenticationService} from './services/AuthenticationService'
import router from './router'

export default {
  name: 'app',
  data: () => ({
    authenticationService: authenticationService
  }),
  computed: {
    user: function () {
      return authenticationService.getUser()
    }
  },
  methods: {
    logout () {
      authenticationService.logout()
      router.push('/login')
    }
  }
}

</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?37431e22